import React from 'react'
import {
  ActivityIcon,
  BlockIcon,
  ContactsIcon,
  DealsIcon,
  DeleteIcon,
  DownloadIcon,
  EditIcon,
  FavoriteIcon,
  FingerprintIcon,
  InformationIcon,
  ServicesIcon,
  SearchIcon,
  SettingsIcon,
  ShopIcon,
  ShoppingCartIcon,
  ViewIcon,
  SmartphonePhotoIcon,
} from '@paypalcorp/pp-react'

const dataPrivacyConfig = {
  permission: {
    default: {
      iconName: <FingerprintIcon />,
    },
    dw2: {
      iconName: <ServicesIcon color="sysColorAccent1Main" />,
    },
  },
  manageCookie: {
    default: {
      iconName: <ActivityIcon />,
    },
    dw2: {
      iconName: <SettingsIcon color="sysColorAccent1Main" />,
    },
  },
  marketing: {
    default: {
      iconName: <FavoriteIcon />,
    },
    dw2: {
      iconName: <DealsIcon color="sysColorAccent1Main" />,
    },
  },
  shopping: {
    default: {
      iconName: <ShoppingCartIcon />,
    },
    dw2: {
      iconName: <ShopIcon color="sysColorAccent1Main" />,
    },
  },
  searchPrivacy: {
    default: {
      iconName: <ViewIcon />,
    },
    dw2: {
      iconName: <SearchIcon color="sysColorAccent1Main" />,
    },
  },
  blockedContacts: {
    default: {
      iconName: <ContactsIcon />,
    },
    dw2: {
      iconName: <BlockIcon color="sysColorAccent1Main" />,
    },
  },
}
const subSectionBadgeClaasName = 'subSection-badge'
const dataPlatformConfig = {
  downloadData: {
    default: {
      iconName: <DownloadIcon />,
      badge: {
        open: { type: 'success', className: subSectionBadgeClaasName },
        progress: { type: 'neutral', className: subSectionBadgeClaasName },
        download: { type: 'feature', className: subSectionBadgeClaasName },
      },
    },
    dw2: {
      iconName: <DownloadIcon color="sysColorAccent1Main" />,
      badge: {
        open: { type: 'feature', className: '' },
        progress: { type: 'feature', className: '' },
        download: { type: 'success', className: '' },
      },
    },
  },
  correctData: {
    default: {
      iconName: <EditIcon />,
    },
    dw2: {
      iconName: <InformationIcon color="sysColorAccent1Main" />,
    },
  },
  verificationData: {
    default: {
      iconName: <SmartphonePhotoIcon />,
    },
    dw2: {
      iconName: <SmartphonePhotoIcon color="sysColorAccent1Main" />,
    },
  },
  deleteData: {
    default: {
      iconName: <DeleteIcon />,
    },
    dw2: {
      iconName: <DeleteIcon color="sysColorAccent1Main" />,
    },
  },
}

export { dataPrivacyConfig, dataPlatformConfig }
